// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"3f863b57","424":"6c19a92a","455":"edb2feee","528":"d8c93251"}[chunkId] + ".chunk.js";
};